var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPackage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 119,
    height: 100,
    viewBox: "0 0 119 100",
    fill: "#1d4690",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -16.021)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.874,49.95,85.056,25.684,59.975,16.021.824,37.49Zm28.96-28.283,9.439,3.8-10.9,4.379-9.342-4.086Z",
    transform: "translate(0.161 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.791,68.56l11.8,5.651L51.435,59.66,25.791,48.27Z",
    transform: "translate(4.793 6.095)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.226,68.229,12.561,61.208.582,74.58,27.226,90Z",
    transform: "translate(0.114 8.527)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.061,39.515,0,74.358l10.294-11.5Z",
    transform: "translate(0 4.418)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.837,68.9V48.735L2.565,37.953l10.723,24.46Z",
    transform: "translate(0.503 4.134)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.669,62.612v49.755l58-33.573L109.6,36.877Z",
    transform: "translate(9.329 3.654)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.418,25.6l-56.5,24.4L54.476,61.8l57.545-25.565Z",
    transform: "translate(4.677 1.878)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.7,60.627,37.791,74.2,50.7,102.258Z",
    transform: "translate(7.068 8.307)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.791,90.6l25.552,14.79L36.785,73.748,25.791,68.482Z",
    transform: "translate(4.793 9.846)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPackage);
export default __webpack_public_path__ + "static/media/package.d54a3202f78c5bbe5b43d4f1ee908a13.svg";
export { ForwardRef as ReactComponent };